import React, { useCallback, useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import { isNil, template } from 'lodash'
import i18n from 'simple-react-i18n'
import ProgressCard from 'components/card/ProgressCard'
import { hasValue } from 'utils/NumberUtil'
import AEPCriterias from 'quality/components/AEPoverview/AEPCriterias'
import PropTypes from 'prop-types'
import { getBeginingOfTheYear, getEndOfTheYear } from 'utils/DateUtil'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import QualityAction from 'quality/actions/QualityAction'
import { exportFile } from 'utils/ExportDataUtil'
import ToastrAction from 'toastr/actions/ToastrAction'
import ExportAction from 'export/actions/ExportAction'
import AEPoverviewPanel, { AEPConformityOverviewPanel } from './AEPoverviewPanel'
import DistributionUnitAction from 'distributionUnit/actions/DistributionUnitAction'
import { getConformityFilterBody } from 'quality/utils/conformityExportUtils'
import AEPwaterTypePanel from './AEPwaterTypePanel'
import AEPparametersPanel from './AEPparametersPanel'
import AEPnonCompliancesPanel from './AEPnonCompliancesPanel'
import useActions from 'utils/customHook/useActions'
import SimpleTabList from 'components/list/SimpleTabList'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ParameterAction from 'referencial/components/parameter/actions/ParameterAction'
import OperationAction from 'quality/actions/OperationAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import AnalysisAction from 'quality/actions/AnalysisAction'
import DtoAnalysisLight from 'quality/dto/analyse/DtoAnalysisLight'
import DtoOperation from 'quality/dto/operation/DtoOperation'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import AdministrationAction from 'administration/actions/AdministrationAction'
import AccountAction from 'account/actions/AccountAction'
import { calculateThresholdsResult } from 'utils/QualityThresholdUtils'
import { THRESHOLD } from 'quality/constants/QualityConstants'
import useLocalStorage from 'utils/customHook/useLocalStorage'
import { Box } from '@mui/material'
import { useLocation } from 'react-router'

const OVERVIEW = 'overview'
const PARAMETERS = 'parameters'
const WATER_TYPE = 'waterType'
const NON_COMPLIANCES = 'nonCompliances'
const SEUILS_REF = 'SEUILS_REFERENCE'
const SEUILS_LIM = 'SEUILS_LIMITE'
const STORAGE_SEUILS_REF = 'DEFAULT_REFERENCE_THRESHOLD'
const STORAGE_SEUILS_LIM = 'DEFAULT_LIMIT_THRESHOLD'
const DEFAULT_SUPPORT = 'defaultSupport'
const DEFAULT_SUPPORT_VALUE = '-1'

const AEPTab = ({
    ids = [],
    filter = {},
    analysis = [],
    operations = [],
    isFirstSearchDone = false,
    dataLoaded = false,
    progress = 0,
    modelExport = [],
    withBackOverview = false,
    conformity,
}) => {
    const {
        qualityThresholds,
    } = useSelector(store => ({
        qualityThresholds: store.QualityReducer.qualityThresholds,
    }), shallowEqual)

    const referenceThresholds = useMemo(() => filter.referenceThreshold && qualityThresholds.find(t => t.thresholdCode == filter.referenceThreshold && t.thresholdType === THRESHOLD.PC)?.thresholds || [], [filter.referenceThreshold, qualityThresholds])
    const limitThresholds = useMemo(() => filter.limitThreshold && qualityThresholds.find(t => t.thresholdCode == filter.limitThreshold && t.thresholdType === THRESHOLD.PC)?.thresholds || [], [filter.limitThreshold, qualityThresholds])

    const thresholdList = useMemo(() => [...referenceThresholds, ...limitThresholds], [limitThresholds, referenceThresholds])

    const formatedAnalysis = useMemo(() => {
        return analysis
            .filter(a => a.remark !== '0')
            .map(a => {
                const operation = operations.find(o => o.id === a.operation && o.qualitometer === a.qualitometer)
                return {
                    ...a,
                    ...calculateThresholdsResult(a, thresholdList),
                    producer: operation?.producer,
                }
            })
    }, [analysis, operations, thresholdList])

    const onExport = (exportData) => {
        const {
            producer,
            year,
            support,
            limitThreshold,
            referenceThreshold,
        } = filter
        const criterias = {
            producer,
            startDate: getBeginingOfTheYear(year),
            endDate: getEndOfTheYear(year),
            support: support !== DEFAULT_SUPPORT_VALUE ? support : undefined,
            stations: ids,
            threshold: hasValue(limitThreshold) ? limitThreshold : referenceThreshold,
        }
        exportFile(exportData, false, {}, false, {}, false, criterias, modelExport)
    }

    return (
        <SimpleTabList
            defaultTab={OVERVIEW}
            tabs={[
                {
                    constant: OVERVIEW,
                    label: i18n.overview,
                    icon: 'playlist_add_check',
                },
                {
                    constant: PARAMETERS,
                    label: i18n.parameter,
                    icon: 'bubble_chart',
                },
                {
                    constant: WATER_TYPE,
                    label: i18n.waterType,
                    icon: 'format_list_bulleted',
                },
                {
                    constant: NON_COMPLIANCES,
                    label: i18n.noncompliances,
                    icon: 'warning',
                },
            ]}
        >
            {
                tab => {
                    if (!isFirstSearchDone) {
                        return (
                            <div className='row no-margin padding-top-1 padding-left-3 padding-bottom-1' >
                                <h5>{i18n.pleaseSearch}</h5>
                            </div>
                        )
                    }
                    if (!dataLoaded) {
                        return (
                            <ProgressCard progress={progress} />
                        )
                    }
                    if (dataLoaded && !analysis.length) {
                        return (
                            <div className='row no-margin padding-top-1 padding-left-3 padding-bottom-1' >
                                <h5>{template(i18n.noAnalysisForYear)({ year: filter.year })}</h5>
                            </div>
                        )
                    }
                    return (
                        <div style={{ padding: '10px' }}>
                            {
                                tab === OVERVIEW && withBackOverview && (
                                    conformity ? (
                                        <AEPConformityOverviewPanel
                                            filter={filter}
                                            onExport={onExport}
                                            result={conformity}
                                        />
                                    ) : (
                                        <ProgressCard indeterminate />
                                    )
                                )
                            }
                            {
                                tab === OVERVIEW && !withBackOverview && (
                                    <AEPoverviewPanel
                                        filter={filter}
                                        onExport={onExport}
                                        thresholdList={thresholdList}
                                        operations={operations}
                                        analysis={formatedAnalysis}
                                    />
                                )
                            }
                            {
                                tab === PARAMETERS && (
                                    <AEPparametersPanel
                                        filter={filter}
                                        onExport={onExport}
                                        thresholdList={thresholdList}
                                        analysis={formatedAnalysis}
                                    />
                                )
                            }
                            {
                                tab === WATER_TYPE && (
                                    <AEPwaterTypePanel
                                        filter={filter}
                                        onExport={onExport}
                                        thresholdList={thresholdList}
                                        analysis={formatedAnalysis}
                                    />
                                )
                            }
                            {
                                tab === NON_COMPLIANCES && (
                                    <AEPnonCompliancesPanel
                                        filter={filter}
                                        onExport={onExport}
                                        operations={operations}
                                        thresholdList={thresholdList}
                                        referenceThresholds={referenceThresholds}
                                        limitThresholds={limitThresholds}
                                        analysis={formatedAnalysis}
                                    />
                                )
                            }
                        </div>
                    )
                }
            }
        </SimpleTabList>
    )
}

AEPTab.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.shape({})),
    filter: PropTypes.shape({}),
    analysis: PropTypes.arrayOf(PropTypes.shape({})),
    operations: PropTypes.arrayOf(PropTypes.shape({})),
    isFirstSearchDone: PropTypes.bool,
    dataLoaded: PropTypes.bool,
    progress: PropTypes.number,
    modelExport: PropTypes.arrayOf(PropTypes.shape({})),
    withBackOverview: PropTypes.bool,
    conformity: PropTypes.shape({}),
}

const AEPOverview = ({
    ids = [],
    distributionUnitId,
}) => {
    const dispatch = useDispatch()

    const {
        accountUserSettings,
        applicationSettings,
    } = useSelector(store => ({
        accountUserSettings: store.AccountReducer.accountUserSettings,
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    useActions(() => ({}), [])

    const thresholdRefSettings = useApplicationSetting(SEUILS_REF, setting => setting ? parseInt(setting) : undefined)
    const thresholdRefAccountSettings = useAccountSetting(SEUILS_REF, setting => setting ? parseInt(setting) : undefined)
    const thresholdRefDefaultSettings = useLocalStorage(STORAGE_SEUILS_REF, setting => setting ? parseInt(setting) : undefined)[0]

    const thresholdLimSettings = useApplicationSetting(SEUILS_LIM, setting => setting ? parseInt(setting) : undefined)
    const thresholdLimAccountSettings = useAccountSetting(SEUILS_LIM, setting => setting ? parseInt(setting) : undefined)
    const thresholdLimDefaultSettings = useLocalStorage(STORAGE_SEUILS_LIM, setting => setting ? parseInt(setting) : undefined)[0]

    const defaultSupport = useAccountSetting(DEFAULT_SUPPORT, setting => setting || undefined)

    // critères transmis dans l'URL (ex : depuis la conformité des UDI), prioritaires sur les critères par défaut
    const { search } = useLocation()
    const urlFilter = useMemo(() => {
        const params = new URLSearchParams(search)
        const toInt = key => params.get(key) ? parseInt(params.get(key)) : undefined
        return {
            hasSupport: params.has('support'),
            support: params.get('support') || undefined,
            year: toInt('year'),
            referenceThreshold: toInt('referenceThreshold'),
            limitThreshold: toInt('limitThreshold'),
        }
    }, [search])

    const [filter, setFilter] = useState({
        support: urlFilter.hasSupport ? urlFilter.support : defaultSupport,
        // UDI : année en cours, chargée automatiquement ; autres pages AEP : année précédente
        year: urlFilter.year ?? (hasValue(distributionUnitId) ? moment().year() : moment().year() - 1),
        producer: undefined,
        referenceThreshold: urlFilter.referenceThreshold ?? thresholdRefDefaultSettings ?? thresholdRefAccountSettings ?? thresholdRefSettings,
        limitThreshold: urlFilter.limitThreshold ?? thresholdLimDefaultSettings ?? thresholdLimAccountSettings ?? thresholdLimSettings,
    })
    const [isFirstSearchDone, setFirstSearchDone] = useState(false)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)
    const [modelExport, setModelExport] = useState([])

    const [operations, setOperations] = useState([])
    const [analysis, setAnalysis] = useState([])
    const [conformity, setConformity] = useState()

    const {
        progress: criteriasProgress,
        isLoaded,
    } = useProgressDispatch(() => [
        dispatch(ParameterAction.fetchParameters()),
        dispatch(QualityAction.fetchRemarks()),
        dispatch(ContributorAction.fetchProducers()),
        dispatch(QualityAction.fetchQualifications()),
        dispatch(QualityAction.fetchStatus()),
        dispatch(ContributorAction.fetchLaboratories()),
        dispatch(ContributorAction.fetchDeterminators()),
    ])

    useEffect(() => {
        const controller = new AbortController()
        if (ids.length) {
            setOperations([])
            dispatch(OperationAction.getAllOperation(ids, controller.signal)).then(op => setOperations(op.map(o => new DtoOperation(o))))
        }
        return () => {
            controller.abort()
        }
    }, [ids])

    useEffect(() => {
        if (!accountUserSettings.length) {
            dispatch(AccountAction.fetchAccountUserSettings())
        }
        if (!applicationSettings.length) {
            dispatch(AdministrationAction.fetchSettings())
        }
        dispatch(ExportAction.getEnvironmentModelsByType('qualityResearch')).then(modelList => setModelExport(modelList))
    }, [])

    const onValidate = useCallback((newFilter) => {
        const {
            support,
            year,
            producer,
            referenceThreshold,
            limitThreshold,
        } = newFilter
        if (!hasValue(referenceThreshold) && !hasValue(limitThreshold)) {
            dispatch(ToastrAction.error(i18n.noThresholdSelectedError))
            return
        }
        dispatch(AdministrationAction.updateSetting(DEFAULT_SUPPORT, newFilter.support || DEFAULT_SUPPORT_VALUE))
        setDataLoaded(false)
        setFirstSearchDone(true)
        setProgress(0)
        setFilter(newFilter)
        const criterias = {
            lightMode: true,
            stations: ids,
            startDate: getBeginingOfTheYear(year),
            endDate: getEndOfTheYear(year),
            support: support !== DEFAULT_SUPPORT_VALUE ? support : undefined,
            producers: isNil(producer) ? undefined : [producer],
        }
        AnalysisAction.getAnalysis(criterias).then(an => {
            setAnalysis(an.map(a => new DtoAnalysisLight(a)))
            setDataLoaded(true)
        })
        // onglet Bilan d'une UDI : calcul côté back
        if (hasValue(distributionUnitId)) {
            setConformity(undefined)
            DistributionUnitAction.promiseConformity([distributionUnitId], getConformityFilterBody(newFilter))
                .then(results => setConformity(results?.[0] || {}))
                .catch(() => setConformity({}))
        }
    }, [dispatch, ids, distributionUnitId])

    // UDI : bilan chargé automatiquement avec les critères par défaut, dès que les stations et les seuils par défaut
    // (réglages chargés de façon asynchrone) sont disponibles
    const [autoSearchDone, setAutoSearchDone] = useState(false)
    const [criteriasKey, setCriteriasKey] = useState(0)
    useEffect(() => {
        if (!hasValue(distributionUnitId) || autoSearchDone || isFirstSearchDone || !isLoaded || !ids.length) {
            return
        }
        const referenceThreshold = urlFilter.referenceThreshold ?? thresholdRefDefaultSettings ?? thresholdRefAccountSettings ?? thresholdRefSettings
        const limitThreshold = urlFilter.limitThreshold ?? thresholdLimDefaultSettings ?? thresholdLimAccountSettings ?? thresholdLimSettings
        if (!hasValue(referenceThreshold) && !hasValue(limitThreshold)) {
            return
        }
        setAutoSearchDone(true)
        setCriteriasKey(prev => prev + 1) // critères remontés avec les seuils par défaut
        onValidate({ ...filter, referenceThreshold, limitThreshold })
    }, [distributionUnitId, autoSearchDone, isFirstSearchDone, isLoaded, ids, urlFilter, thresholdRefDefaultSettings, thresholdRefAccountSettings, thresholdRefSettings, thresholdLimDefaultSettings, thresholdLimAccountSettings, thresholdLimSettings])

    if (!isLoaded) {
        return <ProgressCard progress={criteriasProgress} />
    }

    return (
        <Box sx={{ paddingBottom: '100px', ml: 2 }}>
            <AEPCriterias
                key={criteriasKey}
                onValidate={onValidate}
                defaultFilter={filter}
                operations={operations}
            />
            <div style={{ paddingTop: '5px' }}>
                <AEPTab
                    ids={ids}
                    filter={filter}
                    operations={operations}
                    analysis={analysis}
                    isFirstSearchDone={isFirstSearchDone}
                    dataLoaded={dataLoaded}
                    progress={progress}
                    modelExport={modelExport}
                    withBackOverview={hasValue(distributionUnitId)}
                    conformity={conformity}
                />
            </div>
        </Box>
    )
}

AEPOverview.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.number).isRequired,
    distributionUnitId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default AEPOverview
export {
    AEPTab,
    OVERVIEW,
    PARAMETERS,
    WATER_TYPE,
    NON_COMPLIANCES,
    SEUILS_REF,
    SEUILS_LIM,
    DEFAULT_SUPPORT,
    DEFAULT_SUPPORT_VALUE,
}